module.exports = __webpack_public_path__ + "assets-cabinet/img/log-out.68fa6527.svg";